var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedInHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin-in",
    clipPath: "url(#clip0_1_45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.75078 26.25H2.30859V8.72464H7.75078V26.25ZM5.02676 6.33402C3.28652 6.33402 1.875 4.89261 1.875 3.15238C1.875 2.31648 2.20706 1.51482 2.79813 0.923746C3.3892 0.332677 4.19086 0.000617981 5.02676 0.000617981C5.86266 0.000617981 6.66432 0.332677 7.25539 0.923746C7.84646 1.51482 8.17852 2.31648 8.17852 3.15238C8.17852 4.89261 6.76641 6.33402 5.02676 6.33402ZM28.1191 26.25H22.6887V17.7188C22.6887 15.6856 22.6477 13.0782 19.8592 13.0782C17.0297 13.0782 16.5961 15.2871 16.5961 17.5723V26.25H11.1598V8.72464H16.3793V11.1153H16.4555C17.182 9.73831 18.9568 8.28519 21.6047 8.28519C27.1125 8.28519 28.125 11.9121 28.125 16.6231V26.25H28.1191Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInHero);
export default __webpack_public_path__ + "static/media/LinkedIn--hero.39cb6f9dd28645061e1275249187b71e.svg";
export { ForwardRef as ReactComponent };